'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _flash = require('../actions/flash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReduxErrorPublisher = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ReduxErrorPublisher, _React$Component);

  function ReduxErrorPublisher() {
    (0, _classCallCheck3.default)(this, ReduxErrorPublisher);
    return (0, _possibleConstructorReturn3.default)(this, (ReduxErrorPublisher.__proto__ || (0, _getPrototypeOf2.default)(ReduxErrorPublisher)).apply(this, arguments));
  }

  (0, _createClass3.default)(ReduxErrorPublisher, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return { publishError: this.publishError.bind(this) };
    }
  }, {
    key: 'publishError',
    value: function publishError(message) {
      this.props.dispatch((0, _flash.setFlash)({ message: message }));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react.Children.only(this.props.children);
    }
  }]);
  return ReduxErrorPublisher;
}(_react2.default.Component), _class2.childContextTypes = {
  publishError: _react.PropTypes.func
}, _temp)) || _class);
exports.default = ReduxErrorPublisher;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/ReduxErrorPublisher.js
// module id = 2335
// module chunks = 0